import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Import translation files
import enCommon from './locales/en/common.json'
import svCommon from './locales/sv/common.json'
import nbCommon from './locales/nb/common.json'
import daCommon from './locales/da/common.json'
import frCommon from './locales/fr/common.json'
import deCommon from './locales/de/common.json'
import nlCommon from './locales/nl/common.json'

const resources = {
  en: { translation: enCommon },
  sv: { translation: svCommon },
  nb: { translation: nbCommon },
  da: { translation: daCommon },
  fr: { translation: frCommon },
  de: { translation: deCommon },
  nl: { translation: nlCommon },
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: { escapeValue: false },
  })

// Function to set language manually
export const setLanguage = (lang: string) => {
  const isSupported = Object.prototype.hasOwnProperty.call(resources, lang)
  i18n.changeLanguage(isSupported ? lang : 'en')
}

export default i18n
